import React, { useMemo } from 'react';
import styled from 'styled-components';

const ContentContainer = styled.div`
  display: flex;
`;

const DisplayFlexStretch = styled.div`
  flex: 0.5;
`;

const DisplayFlex = styled.div`
  display: flex;
  justify-content: center;
`;

type HeatmapLegendProps = {
  size: number;
  colorScheme: string[];
  data?: {
    col_nodes: Array<{ name: string; description: string }>;
    row_nodes: Array<{ name: string; description: string }>;
    data: number[][];
  };
  showGradient?: boolean;
  valueFormatter?: (value: number) => string;
};

const formatValue = (value: number) => value.toFixed(2);

export function HeatmapLegend({
  colorScheme,
  data,
  showGradient = false,
  valueFormatter = formatValue,
  size: _size,
}: HeatmapLegendProps) {
  const [minValue, maxValue] = useMemo(() => {
    const flatValues = data?.data?.flat() ?? [];
    if (flatValues.length === 0) {
      return [0, 1];
    }

    const min = Math.min(...flatValues);
    const max = Math.max(...flatValues);

    return [min, max];
  }, [data?.data]);

  const gradientStops = useMemo(() => colorScheme?.join(', ') ?? '', [colorScheme]);

  if (!showGradient || !colorScheme?.length || !gradientStops) {
    return null;
  }

  return (
    <DisplayFlex>
      <DisplayFlexStretch style={{ backgroundImage: `linear-gradient(to right, ${gradientStops})` }}>
        <ContentContainer style={{ justifyContent: 'space-between' }}>
          <div>{valueFormatter(minValue)}</div>
          <div>{valueFormatter(maxValue)}</div>
        </ContentContainer>
      </DisplayFlexStretch>
    </DisplayFlex>
  );
}
